import { zaokr, zl } from "../../../../functions/utilities";

const MieszkaniecDaneWodaRozliczenieWydrukLegenda = props => {
    
    const { rozliczenieWodyAkt, procent } = props;    

    return (
        <section style={{marginTop: "80px"}}>
            <div>
                <p style={{fontSize: "0.75rem"}}>Legenda:</p>
                <table style={{fontSize: "0.7rem"}}>
                    <tbody>
                        <tr>
                            <td style={{padding: "2px 10px", fontStyle: "italic"}}>
                                koszt zakupu zimnej wody (wg ceny PWiK):
                            </td>
                            <td style={{padding: "2px 10px", fontStyle: "italic"}}>
                                {`${zl(rozliczenieWodyAkt?.metr_3_zimnej)} /m³`}
                            </td>
                        </tr>       
                        {
                            rozliczenieWodyAkt?.abonament_dzien > 0 && (
                                <tr>
                                    <td style={{padding: "2px 10px", fontStyle: "italic"}}>
                                        abonament (wyliczony wg faktur PEC):
                                    </td>
                                    <td style={{padding: "2px 10px", fontStyle: "italic"}}>
                                        {`${zaokr(procent?.abonament_pozorny_msc)}zł /m² /miesiąc`}
                                    </td>
                                </tr>
                            )
                        }            
                        <tr>
                            <td style={{padding: "2px 10px", fontStyle: "italic"}}>
                                koszt podgrzania wody (wyliczony wg faktur PEC):
                            </td>
                            <td style={{padding: "2px 10px", fontStyle: "italic"}}>
                                {`${zl(rozliczenieWodyAkt?.kosztPodgrzaniaCieplej)} /m³`}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
    )
}

export default MieszkaniecDaneWodaRozliczenieWydrukLegenda;